import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svg/SvgIcon';

const iconStyle = {
  width: 22,
  height: 22,
};

const Users = ({ color, style, ...props }) => (
  /* eslint-disable max-len */
  <SvgIcon
    {...props}
    viewBox="0 0 512.008 514.032"
    style={{ ...style, ...iconStyle }}
  >
    <path
      fill={color || '#C4C8CE'}
      d="M373 418.656l-100.736-55.8c37.44-29.456 47.608-87.344 47.608-119.8v-67.56c0-44.736-59.44-94.56-119.144-94.56-59.688 0-120.704 49.832-120.704 94.56v67.56c0 29.512 12.488 89.216 50.312 119.544L27 418.656S0 430.688 0 445.688v40.544c0 14.92 12.112 27.032 27 27.032h346c14.904 0 27.016-12.112 27.016-27.032v-40.544c0-15.904-27.016-27.032-27.016-27.032zm-4.984 62.608H32v-28.608c2.296-1.672 5.504-3.608 8.032-4.768.752-.344 1.504-.704 2.216-1.112l103.344-56.048c9.424-5.112 15.672-14.592 16.624-25.264s-3.504-21.128-11.856-27.832c-26.832-21.512-38.328-69.16-38.328-94.576v-67.56c0-22.984 43.328-62.56 88.704-62.56 46.216 0 87.144 39.032 87.144 62.56v67.56c0 25.064-7.784 72.92-35.392 94.64-8.456 6.656-13 17.112-12.112 27.832.904 10.72 7.128 20.264 16.56 25.424l100.736 55.8c.888.488 2.016 1.016 2.952 1.424 2.36 1 5.264 2.672 7.392 4.144v28.944zm116.968-142.28l-102.232-55.8c37.44-29.456 49.112-87.344 49.112-119.8v-67.56c0-44.736-60.936-95.064-120.64-95.064-38.8 0-78.472 21.096-101.56 48.112 13.168.816 27.688.832 40.232 4.832 16.856-13.128 38.184-20.936 61.328-20.936 46.216 0 88.64 39.528 88.64 63.064v67.56c0 25.064-9.28 72.92-36.888 94.64-8.456 6.656-13 17.112-12.112 27.832.904 10.72 7.128 20.264 16.56 25.424l102.232 55.8c.888.488 2.016 1.016 2.952 1.424 2.36 1 5.264 2.672 7.392 4.144v28.456h-64.592c9.752 7.36 12.704 17.888 16.488 32h53.096c14.904 0 27.016-12.112 27.016-27.032v-40.048c-.008-15.92-27.024-27.048-27.024-27.048z"
    />
  </SvgIcon>
  /* eslint-enable max-len */
);

export default pure(Users);
